export default __webpack_public_path__ + "static/media/background.07d4d927.jpg";